// ============================================================================
// CALORIAS QUEIMADAS NO TREINO — duplicado em 16/09/2026 direto de
// fitclutch-mobile/src/lib/calories.js, sem nenhuma alteração (cálculo real
// baseado em MET, mesma fórmula do app mobile).
// ============================================================================

const MET_RESISTANCE_MODERATE = 5.0;

export const DEFAULT_BODY_WEIGHT_KG = 70;

export function computeCaloriesBurned({ durationSeconds, weightKg, met = MET_RESISTANCE_MODERATE }) {
  if (!durationSeconds || durationSeconds <= 0) return 0;
  const effectiveWeight = weightKg ?? DEFAULT_BODY_WEIGHT_KG;
  const hours = durationSeconds / 3600;
  const kcal = met * effectiveWeight * hours;
  return Math.round(kcal);
}
